import { render, staticRenderFns } from "./WarrantyModal.vue?vue&type=template&id=563d81e6&scoped=true"
import script from "./WarrantyModal.vue?vue&type=script&lang=js"
export * from "./WarrantyModal.vue?vue&type=script&lang=js"
import style0 from "./WarrantyModal.vue?vue&type=style&index=0&id=563d81e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563d81e6",
  null
  
)

export default component.exports